module.exports = "<span>\n  {{name|e}}\n</span>\n";
